// 客户列表
<template>
  <div class="sld_after_connection_list">
    <MemberTitle style="padding-left: 20px"></MemberTitle>
    <div class="after_sales_list_main">
      <div class="after_sales_title">
        <div class="search_con flex_row_start_center">
          <div class="search_incon flex_row_start_center">
            <el-input class="search_input" v-model="orderSn" placeholder="会员名/单位名称/手机号/客户别名" clearable @clear="clear">
            </el-input>
            <div class="search pointer" @click="getAfterSalesDet">
              {{ L["搜索"] }}
            </div>
          </div>
        </div>
        <!-- <div class="search_out pointer">导出全部账单</div> -->
      </div>
      <div class="after_sales_list">
        <div class="after_sales_list_title grid-header-row">
          <div class="title_item">会员名</div>
          <div class="title_item">客户名称/别名</div>
          <div class="title_item">单位名称</div>
          <div class="title_item">手机号</div>
          <div class="title_item">可用余额</div>
          <div class="title_item title-options">{{ L["操作"] }}</div>
        </div>
        <div class="after_sales_list_con">
          <div class="list_con_pre" v-for="(item, index) in afterSalesList.data" :key="index">
            <div class="list_con grid-data-row">
              
              <div class="list_item">
                {{ item.memberName ? item.memberName : '--' }}
              </div>
              <div class="list_item multi-line">
                <div class="name-line">{{ item.memberTrueName ? item.memberTrueName : '--' }}</div>
                <div class="remark-line">{{ item.remark ? item.remark : '--' }}</div>
              </div>
              <div class="list_item">
                {{ item.companyName ? item.companyName : '--' }}
              </div>
              <div class="list_item">
                {{ item.memberMobile ? item.memberMobile : '--' }}
              </div>
              <div class="list_item">
                {{ item.creditBalanceAmount ? item.creditBalanceAmount : '--' }}
              </div>
              <div class="list_item list-options">
                <div class="options-container">
                  <span class="cursor_pointer option-btn" @click="goRefundDetail('/member/connection/credit', item)">申请授信</span>
                  <span class="cursor_pointer option-btn" @click="goRefundDetail('/member/connection/valet', item)">代客下单</span>
                </div>
              </div>

            </div>
          </div>
          <SldCommonEmpty v-show="!afterSalesList.data.length" totalWidth="900"></SldCommonEmpty>
          <div class=" sld_pagination sld_page_bottom">
            <el-pagination @current-change="handleCurrentChange" background :currentPage="current"
              :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" :hide-on-single-page="false"
              v-if="afterSalesList.data.length > 0">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from 'vuex'
import { onMounted, reactive, ref, getCurrentInstance, watchEffect } from "vue";
import { ElMessage, ElPagination } from "element-plus";
import SldCommonEmpty from "../../../components/SldCommonEmpty";
import { useRouter } from "vue-router";
import MemberTitle from "../../../components/MemberTitles";

export default {
  components: {
    ElPagination,
    MemberTitle,
    SldCommonEmpty,
  },
  setup() {
    const store = useStore()
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const router = useRouter();
    const curTitleId = ref(1); //当前选中的标题id
    const afterSalesList = reactive({ data: [] }); //售后列表
    const pageSize = ref(10);
    const current = ref(1);
    const total = ref(""); //总条数
    const orderSn = ref(""); //总条数
    const aftersalesDetail = reactive({ data: {} }); //售后列表详情数据

    const toStore = (storeId) => {
      if (storeId == 0) {
        return;
      }
      proxy.$goStoreDetail(storeId);
    };

    onMounted(() => {
      // 非销售员 登录进来之后跳转首页
      if (store.state.memberInfo.isSale == 0) {
        router.push({ path: "/index" });
      }
      getAfterSalesDet();
    });
    //   router.beforeEach((to, from, next) => {
    //     if (to.query.type == "return") {
    //       curTitleId.value = 2; //退款退货
    //     } else {
    //       curTitleId.value = 1; //仅退款
    //     }
    //     getAfterSalesDet();
    //     next();
    //   });

    //清空搜索订单
    const clear = () => {
      orderSn.value = ""
      getAfterSalesDet()
    }

    //获取客户列表
    const getAfterSalesDet = () => {
      let params = {
        current: current.value,
        pageSize: pageSize.value,
      };
      if (orderSn.value) {
        params.keyword = orderSn.value;
      }
      proxy.$get("v3/member/front/custom/customList", params).then((res) => {
        if (res.state == 200) {
          let result = res.data.list;
          afterSalesList.data = result;
          current.value = res.data.pagination.current;
          total.value = res.data.pagination.total;
        } else {
          ElMessage.error(res.data);
        }
      });
    };
    //选择类型
    const titleNav = (titleId) => {
      curTitleId.value = titleId;
      getAfterSalesDet();
    };
    //上一页
    const handlePrevCilickChange = () => {
      current.value--;
      getAfterSalesDet();
    };
    //下一页
    const handleNextCilickChange = () => {
      current.value++;
      getAfterSalesDet();
    };
    //选择页面
    const handleCurrentChange = (e) => {
      current.value = e
      getAfterSalesDet();
    };
    //申请授信
    const goRefundDetail = (url, item) => {
      if (url == '/member/connection/credit') {
        router.push({
          path: url,
          query: {
            id: item.memberId,
            companyName: item.companyName,
            memberName: item.memberName
          }
        });
      } else {
        router.push({
          path: url,
          query: {
            id: item.memberId,
            companyName: item.companyName,
            memberName: item.memberName
          }
        });
      }
    };
    //填写物流单号
    const logisticsBill = (afterSalesItem) => {
      router.push({
        path: "/member/order/logistics",
        query: {
          afsSn: afterSalesItem.afsSn,
        },
      });
    };
    //去商品详情页
    const goGoodsDetail = (productId) => {
      proxy.$goGoodsDetail(productId);
    };

    return {
      L,
      curTitleId,
      afterSalesList,
      titleNav,
      pageSize,
      current,
      aftersalesDetail,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      goRefundDetail,
      logisticsBill,
      goGoodsDetail,
      toStore,
      total,
      orderSn,
      clear,
      getAfterSalesDet
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../../style/base.scss";
@import "../../../style/iconfont.css";
@import "../../../style/connection.scss";


// 定义网格布局
.grid-header-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1.5fr 1fr 1fr 1.2fr;
  height: 40px; // 固定高度
  align-items: center;
}

// 数据行 - 自适应高度
.grid-data-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1.5fr 1fr 1fr 1.2fr;
  align-items: stretch; // 让所有子元素拉伸到相同高度
  min-height: auto; // 移除固定的最小高度
}

.title_item, .list_item {
  padding: 8px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  
  &.title-options, &.list-options {
    padding: 0;
  }
}

.title_item {
  font-weight: bold;
  background-color: #f5f7fa;
  justify-content: center;
  height: 100%; // 
}

.list_item {
  word-break: break-word;
  line-height: 1.4;
  
  &:not(:last-child) {
    border-right: 1px solid #ebeef5;
  }
  
  &.multi-line {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 6px 8px; // 调整多行内容的内边距
    
    .name-line {
      font-weight: normal;
    }
    
    .remark-line {
      font-size: 12px;
      color: #999;
      margin-top: 2px;
    }
  }
}

// 操作列特殊处理 - 不使用stretch对齐，而是居中对齐
.list-options {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 0 !important; // 覆盖默认padding
}

.options-container {
  display: flex;
  flex-direction: column;
  gap: 4px; // 减少按钮间距
  padding: 4px 8px; // 减少容器内边距
  width: 100%;
  align-items: center;
  
  .option-btn {
    display: block;
    text-align: center;
    padding: 4px 8px; // 合适的内边距，增加点击区域
    font-size: 12px; // 统一字体大小
    color: #409eff; // Element UI 默认蓝色，表示可点击
    cursor: pointer;
    border-radius: 3px; // 圆角
    
    &:hover {
      background-color: #ecf5ff; // 悬停背景色
      color: #409eff;
    }
    
    &:not(:first-child) {
      // 确保每个按钮底部对齐
      margin-top: 0;
    }
  }
}

.storeName {
  color: #333;

  &:hover {
    color: $colorMain;
  }
}


</style>
<style lang="scss">
.sld_after_connection_list {
  .search_con {
    height: 44px;
    padding-top: 18px;
    padding-bottom: 18px;
    box-sizing: border-box;

    .search_incon {
      width: 321px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #e8e8f1;
    }

    .search_input {
      width: 323px;
      border-right: none;
    }

    .el-input__inner {
      height: 29px;
      padding-left: 11px;
      border: none;
      box-sizing: border-box;
      outline: none;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }

    .search {
      width: 70px;
      height: 32px;
      border: none;
      background-color: #f7f7f7;
      color: #000;
      line-height: 32px;
      text-align: center;
      font-size: 12px;
    }

    .el-select {
      height: 34px;
      line-height: 34px;
      box-shadow: 0 0 3px 2px #f5f5f5;

      .el-input {
        width: 150px;
        height: 34px;
      }

      .el-input__inner {
        position: absolute;
        top: 0;
        left: 0;
        height: 34px;
        padding-left: 10px;
        padding-right: 10px;
        border: none;
        box-sizing: border-box;
        outline: none;
      }

      .el-input__suffix {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .search_out {
    // width: 70px;
    padding: 0 5px;
    height: 40px;
    border: none;
    background-color: #f7f7f7;
    color: #000;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
  }
}
</style>